<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container-fluid">
      <!-- Logo -->
      <a class="navbar-brand" href="#">
        <img src="../assets/pratima v card -02 1.png" alt="" height="70" width="230" class="p-logo">
      </a>

      <!-- Toggler button for small screens -->
      <button
        class="navbar-toggler border-0"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasNavbar"
        aria-controls="offcanvasNavbar"
      >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="33" height="33">
        <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"></path>
      </svg>

      </button>

      <!-- Off-canvas sidebar -->
      <div
        class="offcanvas offcanvas-end small-height-offcanvas"
        tabindex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
      >
        <div class="offcanvas-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div class="offcanvas-body">
          <ul class="navbar-nav justify-content-center flex-grow-1">
            <li class="nav-item" v-for="link in navLinks" :key="link.name">
              <router-link
                class="nav-link"
                :to="{ name: link.routeName }"
                :class="{ active: isActive(link.routeName) }"
                @mouseover="hovered = link.routeName"
                @mouseleave="hovered = ''"
              >
                {{ link.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      hovered: '',
      navLinks: [
        { label: 'Home', routeName: 'HomePage' },
        { label: 'About Us', routeName: 'AboutUsPage' },
        { label: 'Services', routeName: 'ServicePage' },
        { label: 'Projects', routeName: 'ProjectsPage' },
        { label: 'Contact Us', routeName: 'ContactUsPage' },
      ],
    };
  },
  methods: {
    isActive(routeName) {
      return this.$route.name === routeName;
    },
    closeOffCanvasOnNavigate() {
      const offCanvas = document.getElementById('offcanvasNavbar');
      if (offCanvas && offCanvas.classList.contains('show')) {
        // Simulate the close button click
        const closeButton = offCanvas.querySelector('.btn-close');
        if (closeButton) closeButton.click();
      }
    },
  },
  mounted() {
    this.$router.afterEach(() => {
      this.closeOffCanvasOnNavigate();
    });
  },
};
</script>

<style scoped>

.navbar{
  position: fixed;
  top: 0;
  z-index: 1030; /* Ensures it appears above other elements */
  width: 100%;
}

.nav-link {
  color: #565D6D; /* Default color */
  transition: color 0.3s ease;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
}

.nav-link:hover,
.nav-link.active {
  color: #197DCA !important;
}

.navbar-nav{
  gap: 7rem;
}

#navbarNav{
  margin-right: 12vh;
}

.p-logo{
  margin-left: 17vh;
}

.navbar-toggler svg {
  fill: currentColor; /* Ensures the SVG inherits the color of the parent */
  display: block; /* Ensures visibility */
}

.navbar-toggler {
  border: none !important; /* Completely removes any border */
  background: transparent !important; /* Removes background color */
  padding: 0; /* Removes any internal padding */
  box-shadow: none !important; /* Ensures no shadow */
}

.navbar-toggler:focus,
.navbar-toggler:active {
  outline: none !important; /* Removes focus outline */
  box-shadow: none !important; /* Ensures no active shadow */
}

@media (max-width: 1373px) {
  .navbar-nav{
    gap: 2rem;
  }

  .nav-link {
    /* font-size: 15px; */
  }

  #navbarNav{
    margin-right: 0px;
  }

  .p-logo{
    margin-left: 0vh;
  }

  .offcanvas {
    transition: transform 0.3s ease-in-out;
    width: 72% !important;
  }

  .small-height-offcanvas {
    height: 55%; /* Adjust to desired height */
    top: 0%; /* Vertically center it */
    border-radius: 10px 0 0 10px; /* Optional rounded corners */
  }

}

@media (max-width:991px) {
  .offcanvas{
    width: 44% !important;
  }
}

@media (max-width:583px) {
  .offcanvas{
    width: 58% !important;
  }
}
</style>
